import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import FileOpenIcon from "@mui/icons-material/FileOpen";
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import {
  Grid,
  Tooltip
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { format, parseISO } from "date-fns";
import { StyledEstablecimientos } from '../../../../styled/Prevencion';

const FormulariosPrevencionCard = ({ data, handleVisualizar, handleEditarResolucion81 }) => {
  const theme = useTheme();

  // vienen como int desde el back
  const estadosFormulario = {
    0: "Finalizado",
    2: "Revisión",
    3: "Observado"
  };

  const getIconosSegunEstado = (formulario) => {
    let actions = []
    if (formulario?.codigoArtFormulario === 3 || formulario?.codigoArtFormulario === 15 || formulario?.codigoArtFormulario === 11 || formulario.estado === 3) {
      actions.push(
        <StyledEstablecimientos.IconPadding key="certificado">
          <Tooltip title="Certificado de presentación" arrow>
            <BookmarkBorderOutlinedIcon
              onClick={() =>
                handleVisualizar(formulario, "Certificado de presentación")
              }
              style={{ color: `${theme.palette.quartary.light}` }}
            />
          </Tooltip>
        </StyledEstablecimientos.IconPadding>
      )
    }
    if (formulario?.codigoArtFormulario === 15 && formulario?.estado === 2) {
      actions.push(
        <StyledEstablecimientos.IconPadding key="editar">
          <Tooltip title="Editar Formulario" arrow>
            <NoteAltOutlinedIcon
              onClick={() => handleEditarResolucion81(formulario?.idFormularioCorrespondiente)}
              style={{ color: theme.palette.senary.light }}
            />
          </Tooltip>
        </StyledEstablecimientos.IconPadding>
      )
    }
    if (
      formulario?.codigoArtFormulario === 3 ||
      formulario?.codigoArtFormulario === 11 ||
      formulario?.codigoArtFormulario === 15
    ) {

      if (formulario?.estado === 2 || formulario.estado === 0 || formulario.estado === 3) {
        actions.push(
          <StyledEstablecimientos.IconPadding key="visualizar">
            <Tooltip title="Visualizar formulario" arrow>
              <FileOpenIcon
                onClick={() =>
                  handleVisualizar(formulario, "Formularios presentados")
                }
                style={{ color: `${theme.palette.secondary.light}` }}
              />
            </Tooltip>
          </StyledEstablecimientos.IconPadding>
        );
      }

    }

    return actions.length === 0 ? null : actions;
  };

  return (
    <div>
      {data?.length > 0 ? (
        data.map((formulario) => {
          let iconosSegunEstado = getIconosSegunEstado(formulario);
          return (
            <StyledEstablecimientos.Card
              elevation={2}
              key={formulario?.idFormularioProgramaPrevencionEmpleador}
            >
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <StyledEstablecimientos.FormularioText variant="body1" estado={formulario?.estado}>
                    {format(
                      parseISO(formulario?.fechaHoraFormulario),
                      "dd/MM/yyyy"
                    )}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={4}>
                  <StyledEstablecimientos.FormularioText variant="body1" estado={formulario?.estado}>
                    {formulario?.nombreFormulario}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <StyledEstablecimientos.FormularioText estado={formulario?.estado}>
                    {formulario?.portalWeb ? "Si" : "No"}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <StyledEstablecimientos.FormularioText estado={formulario?.estado}>
                    {estadosFormulario[formulario?.estado]}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  {iconosSegunEstado}
                </Grid>
              </Grid>
            </StyledEstablecimientos.Card>
          );
        })
      ) : (
        <StyledEstablecimientos.EmptyState variant="body2">
          No hay formularios para este establecimiento
        </StyledEstablecimientos.EmptyState>
      )}
    </div>
  );
};

export default FormulariosPrevencionCard;
